const SESSION_KEY = 'bookinggood.experimental'

// UI preview only. Each application origin keeps its own tab-scoped opt-in.
const isExperimentalSession = browser => {
    const requested = new URLSearchParams(browser.location.search).has('experimental')
    try {
        if (requested) browser.sessionStorage.setItem(SESSION_KEY, 'true')
        return requested || browser.sessionStorage.getItem(SESSION_KEY) === 'true'
    } catch {
        return requested
    }
}

module.exports = { isExperimentalSession }
